module.exports = __webpack_public_path__ + "img/hyperx-pulsefire-raid-preview.7bab17e9.png";